<template>
  <el-container class="joined-room-container">
    <el-container class="joined-room-wrapper">
      <JoinRoomPrompt />

      <SidePaneSmallToolbar
        v-if="!isRestrictedUser()"
        class="side-panel--small"
        :class="[isBreakoutRoomsHidden ? 'inward' : 'outward']"
      />
      <!-- <el-aside class="side-panel__dummy" v-if="!showBreakouts"> -->
      <!-- Hack to show controls when we mouse over, as we can't detect mouse over on jitsi iframe -->
      <!-- </el-aside> -->
      <el-main class="main-container">
        <Header />
        <div class="rooms-screen-container">
            <el-aside
                v-if="!isRestrictedUser()"
                class="side-panel"
                :class="[isBreakoutRoomsHidden ? 'hide' : 'show']"
            >
                <Rooms class="room-list"></Rooms>
            </el-aside>
            <Screen
            :jitsiApi="jitsiApi"
            :tileViewEnabled="tileViewEnabled"
            :filmStripVisible="filmStripVisible"
            />
        </div>
      </el-main>
      <div class="controls-container">
        <transition name="slide-fade">
          <Controls
            v-if="(showControls && !isRestrictedUser())"
            :tileViewEnabled="tileViewEnabled"
            :filmStripVisible="filmStripVisible"
          />
        </transition>
        <!-- <div class="facilitator-controls__dummy"> -->
        <!-- Hack to show controls when we mouse over, as we can't detect mouse over on jitsi iframe -->
        <!-- </div> -->
      </div>
      <Password
        v-if="passwordFormVisibility"
        :room="currentRoom"
        :on-success="onPasswordValid"
        :on-failure="onPasswordNotValid"
      />
    </el-container>
  </el-container>
</template>

<script>
import _ from "underscore";
import Rooms from "./room/Rooms";
import JoinRoomPrompt from "./room/JoinRoomPrompt";
import Controls from "./Controls";
import Header from "./room/Header";
import Screen from "./room/Screen";
import Password from "./room/Password";
import Message from "./room/Message";
import LastNPrompt from "./room/LastNPrompt";
import moment from "moment";
import Poll from "./room/Poll";
import {
  initJitsi,
//   isMobile,
  showMessage,
  playAudio,
  getSocketPayload,
  setMobileToolabarButtons,
  isOnlyMobile,
  JITSI_CONSTANTS

} from "../utils";
import { mapState, mapGetters } from "vuex";
import axios from "../client";
import SecTimer from "./timer/SecTimer";
import BrodcastNotification from "./room/BrodcastNotification";
import LobbyNotification from "./room/LobbyNotification";
import VideoModeWarning from "./room/VideoModeWarning";
import SidePaneSmallToolbar from "./room/SidePaneSmallToolbar";
import { getToolbarButtons } from "../utils/toolbarButtonsConfig";

export default {
  name: "JoinedRoom",
  components: {
    JoinRoomPrompt,
    Rooms,
    Controls,
    Header,
    Screen,
    Password,
    // eslint-disable-next-line vue/no-unused-components
    Message,
    // eslint-disable-next-line vue/no-unused-components
    Poll,
    // eslint-disable-next-line vue/no-unused-components
    SecTimer,
    // eslint-disable-next-line vue/no-unused-components
    LastNPrompt,
    // eslint-disable-next-line vue/no-unused-components
    BrodcastNotification,
    // eslint-disable-next-line vue/no-unused-components
    LobbyNotification,
    // eslint-disable-next-line vue/no-unused-components
    VideoModeWarning,
    SidePaneSmallToolbar
  },

  data: function() {
    return {
      jitsiApi: undefined,
      passwordFormVisibility: false,
      socketErrorShowCount: 0,
      tileViewEnabled: false,
      filmStripVisible: true,
      prevPath: {},
      inactivityInterval: null,
      inactivityCounter: 0, // in sec
      timeoutObj: null
    };
  },
  mounted: async function() {
    this.$store.dispatch("user/refreshTokens", null);
    this.$store.dispatch("user/getControls", this.mainRoom.name);
    localStorage.setItem('mainRoom', this.$route.params.roomName);
    if (this.currentRoom.password) {
        this.passwordFormVisibility = true
    } else {
        await this.initSocketListeners();
        await this.initJitsi();
    }
    window.addEventListener("beforeunload", this.handleClose);
    window.addEventListener('resize', this.handleResize);


    // const body = document.querySelector('body')
    // body.addEventListener('mousemove', this.showControlWindows)
    // body.addEventListener('keypress', this.showControlWindows)
    // this.setInactivityInterval()
  },

  beforeDestroy: function() {
    this.socket.emit(
      "LEAVE_ROOM"
    );
    this.socket.off("BROADCAST");
    this.socket.off(this.currentRoom._id + "ROOM_BROADCAST_MESSAGE");
    this.socket.off(`MESSAGE_USER_${this.profile.email}`);
    this.socket.off(this.mainRoom._id + "BROADCAST_MESSAGE");
    this.socket.off(this.roomToJoin._id + "FORCE_TO_LOBBY");
  },

  methods: {
    joinCurrentRoom() {
      this.socket.emit(
        "JOIN_TO_ROOM",
        getSocketPayload({ roomId: this.currentRoom._id })
      );
    },
    joinPersonalRoom() {
      const email = this.profile.email;
      if (!email) return;
      this.socket.emit("JOIN_PERSONAL_ROOM", getSocketPayload({ email }));
    },
    getCurrentRoomData(){
        this.socket.emit("GET_CURRENT_ROOM_DATA",getSocketPayload({ roomId: this.currentRoom._id }));
    },
    updateCurrentRoomParticipants(room){
        this.jitsiApi?.getRoomsInfo().then(rooms => {
            const currentRoomInfo =_.find(rooms.rooms, (roomObj) => {
                return roomObj.id?.startsWith(room.roomId);
            });
            if(!currentRoomInfo)return;
            this.$store.commit("rooms/setParticipants", currentRoomInfo.participants);
            if(currentRoomInfo.participants.length!== room.participants.length){
                this.participantsDataCorrectionHandler(room, room.participants,currentRoomInfo.participants);
            }
        });
    },
    initSocketListeners: function() {
        this.joinCurrentRoom();
        this.joinPersonalRoom();

      // this event is fired on adding the new room/adding the timer/ editing the room details
      this.socket.on(this.mainRoom._id + "update", room => {
        /*   if (
                    room._id === this.currentRoom._id &&
                    room.lastN !== this.currentRoom.lastN
                ) {
                    this.$store.commit('rooms/updateRoom', room);
                    this.setJitsiApi();
                } else { */
        this.$store.commit("rooms/updateRoom", room);
        // }
      });

      this.socket.on(this.mainRoom._id + "deleteAll", () => {
        this.$store.commit("rooms/resetRooms");
      });

      // It sets the Socket Rooms data on joining the room
      this.socket.on("ROOM_DATA", rooms => {
          this.$store.commit("rooms/setRooms", rooms);
          this.$store.commit("rooms/setSocketRooms", rooms);
          const curRoom = rooms.find(room=> room._id ===this.currentRoom._id || room.roomId ===this.currentRoom._id);
          if (!curRoom) return;
          this.updateCurrentRoomParticipants(curRoom);
      });

      // It updates the room data for any action like Ask help, shared links update
      this.socket.on("ROOM_UPDATE", room => {
        this.$store.commit("rooms/updateRoom", room);
        if (this.currentRoom._id === room.roomId) {
            this.updateCurrentRoomParticipants(room);
        } else {
          this.$store.commit("rooms/setParticipantsOfRoom", room);
        }
      });

      this.socket.on(this.mainRoom.name + "CONTROLS", () => {
        this.$store.dispatch("user/getControls", this.mainRoom.name);
      });

      this.socket.on(this.mainRoom._id + "GET_ALL_ROOMS", async mainRoom => {
        await axios.get("/api/rooms?parent=" + mainRoom._id).then(response => {
          const rooms = [].concat(mainRoom, response.data);
          this.$store.commit("rooms/setRooms", rooms);
        });
      });

      this.socket.on(
        this.mainRoom._id + "BROADCAST_MESSAGE",
        (message, time, userName) => {
          const element = this.$createElement;
          time = moment
            .unix(time)
            .local()
            .format("HH:mm");
          this.$notify({
            message: element("p", null, [
              element(
                "BrodcastNotification",
                {
                  props: {
                    time: time,
                    message: message,
                    userName: userName
                  }
                },
                null
              )
            ]),
            duration: -1,
            offset: 50
          });
        }
      );

      this.socket.on(
        this.mainRoom._id + "POLL",
        (message, pollId, currentTime, userName) => {
          currentTime = moment
            .unix(currentTime)
            .local()
            .format("HH:mm:ss");
          this.showPoll(message, pollId, currentTime, userName);
        }
      );

      this.socket.on("TOKEN_EXPIRED", data => {
        if (data.error === "TOKEN_EXPIRED") {
          const callback = () => {
            const eventName = data.listener ? data.listener : data.event;
            data.error = undefined;
            this.socket.emit(eventName, getSocketPayload(data));
          };
          this.$store.dispatch("user/refreshTokens", callback);
        }
      });

      this.socket.on(this.roomToJoin._id + "FORCE_TO_LOBBY", () => {
        this.notifyAndForceJoinMainRoom();
      });

      this.socket.on(this.mainRoom._id + "delete", room => {
        this.$store.commit("rooms/removeRoom", room);
      });

      this.socket.on("error", this.handleSocketError);
      this.socket.on("connect_error", this.handleSocketError);
      this.socket.on("connect_failed", this.handleSocketError);
      this.socket.on("reconnect_failed", this.handleSocketError);
      this.socket.on("reconnect", this.handleSocketReconnection);
      this.socket.on("connect", this.handleSocketConnection);

      this.socket.on("ROOM_PARTICIPANT_NOTIFICATION", data => {
        if (data.eventType === "userLimitExceed" && this.currentRoom._id ===data.roomId) {
          const isParticipantNotExist = data.participants.every(
            p => p.participantId !== this.currentParticipant?.id
          );
          if (isParticipantNotExist && this.currentParticipant) {

            if (this.prevPath.name === "Join") {
              this.$router.push(this.prevPath.fullPath);
              showMessage(
                "Sorry this room is full, you are being returned back to your previous room",
                "error"
              );
            } else {
              this.$router.push({ name: "Home" });
              this.$store.commit("rooms/setCurrentParticipant", null)
              showMessage("Max users limit reached", "error");
            }
          }
          /* } else if (
                    data.eventType == 'switchToExpandedRoomNotification'
                ) {
                    if (this.$store.state.user.controls['LAST_N']) {
                        const element = this.$createElement;
                        const time = moment(moment.now()).format('HH:mm');
                        this.$notify({
                            message: element('p', null, [
                                element(
                                    'LastNPrompt',
                                    {
                                        style: 'color: teal',
                                        props: {
                                            time: time,
                                            message: `Your room has a large number of participants do you want to swap to an expanded mode?`,
                                            messageHeader: 'Want to swap to expanded mode?',
                                            type:'expanded',
                                            currentRoom:this.currentRoom,
                                            mainRoom:this.mainRoom
                                        },
                                    },
                                    null
                                ),
                            ]),
                            duration: -1,
                        });
                    }
                } else if (this.$store.state.user.controls['LAST_N']) {
                    const element = this.$createElement;
                    const time = moment(moment.now()).format('HH:mm');
                    this.$notify({
                        message: element('p', null, [
                            element(
                                'LastNPrompt',
                                {
                                    style: 'color: teal',
                                    props: {
                                        time: time,
                                        message: `Your room has under ${data.thresholdRoomParticipantsLimit} people, do you want to swap to standard viewing mode?`,
                                        messageHeader: 'Want to swap to standard viewing mode?',
                                        type:'standard',
                                        currentRoom:this.currentRoom,
                                        mainRoom:this.mainRoom
                                    },
                                },
                                null
                            ),
                        ]),
                        duration: -1,
                    });
                    */
        }
      });
    },

    showPoll(message, pollId, time, userName) {
      const element = this.$createElement;
      this.$notify({
        message: element("p", null, [
          element(
            "Poll",
            {
              style: "color: teal",
              props: {
                pollId: pollId,
                socket: this.socket,
                time: time,
                message: message,
                userName: userName
              }
            },
            null
          )
        ]),
        duration: -1,
        offset: 50
      });
    },

    showBroadCastMessage(time, message, userName, messageHeader) {
      const element = this.$createElement;
      time = moment
        .unix(time)
        .local()
        .format("HH:mm");
      this.$notify({
        message: element("p", null, [
          element(
            "Message",
            {
              style: "color: teal",
              props: {
                time: time,
                message: message,
                userName: userName,
                messageHeader: messageHeader
              }
            },
            null
          )
        ]),
        duration: -1,
        offset: 50
      });
    },

    updateJitsiConfigs: function(controls) {
        // Detected update to 'can-record' facilitator perm for this user
        // Update the toolbar controls accordingly
        const canRecord = controls['CAN_RECORD_VIDEO'] || false;
        let buttons = getToolbarButtons(canRecord);
        const toolbar_buttons = setMobileToolabarButtons(buttons);


        // Attempt Jitsi overwrite initialized configs
        if (this.jitsiApi)
            this.jitsiApi.executeCommand(
                'overwriteConfig',
                { toolbarButtons: toolbar_buttons }
            );
    },

    notifyAndForceJoinMainRoom: function() {
      if (
        this.currentRoom._id === this.roomToJoin ||
        this.currentRoom.mainRoom !== this.roomToJoin.mainRoom
      ) {
        setTimeout(playAudio, 28000);
        return;
      }
      playAudio();
      const element = this.$createElement;
      this.$notify({
        title: "",
        message: element("p", null, [
          element(
            "LobbyNotification",
            { props: { roomName: this.roomToJoin.name } },
            null
          )
        ]),
        duration: 29000,
        offset: 50
      });
      let joinRoom = () => {
        clearTimeout(this.timerId);
        this.$notify.closeAll();
        if (
          this.currentRoom._id !== this.roomToJoin &&
          this.currentRoom.mainRoom === this.roomToJoin.mainRoom
        ) {
          playAudio();
          this.$store.commit("rooms/changeRoom", this.currentRoom);
          this.joinRoom(this.roomToJoin);
        }
      };
      this.timerId = setTimeout(joinRoom, 30000);
    },
    onPasswordValid: async function() {
      this.passwordFormVisibility = false;
      await this.initSocketListeners();
      await this.initJitsi();
    },

    onPasswordNotValid: function() {
      this.passwordFormVisibility = false;
      this.$router.push({ path: "/" });
    },

    participantsDataCorrectionHandler(currentRoom, roomParticipants, jitsiParticipants) {
        const data = {
            event:null,
            eventType:"PARTICIPANT_DATA_CORRECTION",
            currentRoom,
            roomParticipants,
            jitsiParticipants
        }
        this.socket.emit("PARTICIPANT_DATA_CORRECTION", getSocketPayload(data));
    },

    participantsChangeHandler(event, eventType) {
      const data = {
        currentRoom: this.currentRoom,
        event,
        eventType
      };
      this.jitsiApi?.getRoomsInfo().then(rooms => {
        const curRoomInfo = rooms?.rooms?.length?rooms.rooms[0]:null;
        data.jitsiParticipants = curRoomInfo.participants;
      }).finally(()=>{
        this.socket.emit("PARTICIPANT_CHANGE", getSocketPayload(data));
      });

    },

    updateDisplayName(displayName) {
      this.$store.commit("rooms/setName", displayName || JITSI_CONSTANTS.defaultDisplayName);
    },
    initJitsi: async function() {
      const lastN = this.currentRoom.lastN || undefined;

      const { jitsiApi, isPreJoinEnabled} = await initJitsi(
        this.currentRoom._id,
        lastN,
        this.isAudioMuted,
        this.isVideoMuted
      );

      // Init JitsiApi
      if (jitsiApi)
        this.jitsiApi = jitsiApi;

      // When prejoin is enabled, disable the loading screen
      if (isPreJoinEnabled)
        this.$store.commit("rooms/setLoading", false);

      this.jitsiApi.addListener("videoConferenceLeft", event => {
        this.participantsChangeHandler({...event, participantId: this.currentParticipant.id}, "videoConferenceLeft");
      });
      this.jitsiApi.addListener("participantJoined", async event=>{
          this.participantsChangeHandler({...event, participantId: event.id}, "participantJoined");

      })
      this.jitsiApi.addListener("participantLeft", event=>{
        this.participantsChangeHandler({...event, participantId: event.id}, "participantLeft");

      })

      this.jitsiApi.addListener("participantKickedOut", event => {
        if (event.kicked.local) {
          this.participantsChangeHandler({...event, participantId: this.currentParticipant.id}, "participantKickedOut");
          sessionStorage.removeItem("session");
        }
      });

      this.jitsiApi.addListener("videoConferenceJoined", event => {
        event.displayName = event.displayName || JITSI_CONSTANTS.defaultDisplayName;
        this.updateJitsiConfigs(this.$store.state.user.controls);
        this.$store.commit("rooms/setIsSwitchingRoom", false);
        this.$store.commit("rooms/setLoading", false);
        this.updateDisplayName(event.displayName);
        this.$store.commit("rooms/setConferenceId", event.id);
        this.$store.commit("rooms/setCurrentParticipant", event);
        this.participantsChangeHandler(event, "videoConferenceJoined");
      });
      this.jitsiApi.addListener("displayNameChange", event => {
        event.displayName = event.displayName || JITSI_CONSTANTS.defaultDisplayName;
        if (this.conferenceId === event.id) {
          this.updateDisplayName(event.displayname);
        }
        this.participantsChangeHandler(event, "displayNameChange");
      });

      this.jitsiApi.on("raiseHandUpdated", event => {
        this.$store.commit("rooms/raiseHand", event);
      });

      this.jitsiApi.on("dominantSpeakerChanged", data => {
        this.$store.commit("rooms/removeRaiseHand", data.id);
      });

      this.jitsiApi.addListener("readyToClose", async() => {
        await this.hangup();
      });
      this.jitsiApi.addListener("audioMuteStatusChanged", data => {
        // Jitsi somehow sends audiomuted event on hangup
        // Do not listen to such events on room change as it will override the local audio state
        if(this.isSwitching) return;
        this.$store.commit("rooms/setAudioState", data.muted);
      });
      this.jitsiApi.addListener("videoMuteStatusChanged", data => {
        // Jitsi somehow sends videomuted event on hangup
        // Do not listen to such events on room change as it will override the local video state
        if(this.isSwitching) return;
        this.$store.commit("rooms/setVideoState", data.muted);
      });
      this.jitsiApi.addListener("tileViewChanged", data => {
        this.tileViewEnabled = data.enabled;
      });
      this.jitsiApi.addListener("filmstripDisplayChanged", data => {
        this.filmStripVisible = data.visible;
      });
      if(isOnlyMobile()){
            this.jitsiApi.addListener("chatUpdated", (event) => {
                this.$store.commit("rooms/setIframeIndex", event.isOpen);
            });
            this.jitsiApi.addListener("participantsPaneToggled", (event) => {
                this.$store.commit("rooms/setIframeIndex", event.open);
            });
      }

    },

    onJitsiHangup: function() {
      this.$router.push({
        path: "/thanksforusing"
      });
    },

    handleSocketError() {
      this.socketErrorShowCount++;
      if (this.socketErrorShowCount % 10 === 1) {
        this.$notify.error({
          title: "Connection Error",
          message:
            "Sorry there was an error, we are trying to reconnect your controls, please try again.",
          showClose: false,
          duration: 3000
        });
      }
    },
    handleSocketConnection() {
      this.joinCurrentRoom();
      this.joinPersonalRoom();
    },

    handleSocketReconnection() {
      this.joinCurrentRoom();
      this.joinPersonalRoom();
      this.getCurrentRoomData();
      this.socketErrorShowCount = 0;
      this.$notify.success({
        title: "Connection Restored",
        message: "Successfully made connection to the server.",
        showClose: false,
        duration: 3000
      });
    },
    handleClose: function() {
      this.jitsiApi.executeCommand("hangup");
    },
    handleResize: function() {
        if(window.innerWidth < 767 && !("ontouchstart" in document.documentElement)){
            this.$store.commit('rooms/hideBreakoutRooms')
            this.$store.commit('rooms/hideFacilitatorControls')
        }
    },
    hangup: async function() {
      // hang the current call, during room change
      // for proper closing of the call and webhook to work
        sessionStorage.removeItem("session");
        localStorage.removeItem("hideBarCloseCount");
        if (this.jitsiApi) {
            this.jitsiApi.dispose();
        }

        // if the user is switching between rooms, create a new jitsi api
        // else if th user is disconnecting, route to `thank for using` page
        if (!this.isSwitching) {
            this.onJitsiHangup();
        } else {
            this.$store.commit("rooms/setLoading", true);
            await this.initJitsi();
        }
    },
    showControlWindows() {
      this.inactivityCounter = 0;
      this.$store.commit("rooms/showControlWindows");
    },

    setInactivityInterval() {
      this.inactivityInterval = setInterval(() => {
        this.inactivityCounter += 1;
        if (this.inactivityCounter >= 5) {
          this.$store.commit("rooms/hideControlWindows");
          this.inactivityCounter = 0;
        }
      }, 1000);
    },

    clearInactivityInterval() {
      this.inactivityCounter = 0;
      clearInterval(this.inactivityInterval);
    },
    switchRoom() {
      this.$store.commit("rooms/setIsSwitchingRoom", true);
      this.hangup();
      this.joinCurrentRoom();
      this.joinPersonalRoom();
    },
    isUserFromAllowedDomain: function(email, allowedDomains) {
        if (!email || email.trim() === "" || !allowedDomains || allowedDomains.length === 0) {
            return false;
        }
        var validDomain = false;
        for(let index = 0; index < allowedDomains.length; index++) {
            if (email.trim().endsWith("@" + allowedDomains[index].trim())) {
                validDomain = true;
                break;
            }
        }
        return validDomain;
    },
    isUserAnonymous: function(loggedIn, email, loginDomainsEnabled, allowedDomains) {
        if (loginDomainsEnabled) {
            const userIsFromAllowedDomain = this.isUserFromAllowedDomain(email, allowedDomains);
            return !userIsFromAllowedDomain;
        }
        return !loggedIn;
    },

    isRestrictedUser: function() {
        return this.restrictControlsForAnonymousUsers && this.isUserAnonymous(this.loggedIn, this.email, this.loginDomainsEnabled, this.allowedDomains);
    }
  },

  watch: {
    controls: function() {
        const controls = this.$store.state.user.controls;
        this.updateJitsiConfigs(controls);
    },
    currentRoom: async function(newVal, oldVal) {
      if (newVal._id !== oldVal._id) {
        this.switchRoom();
        this.socket.off(oldVal._id + "ROOM_BROADCAST_MESSAGE");
        this.socket.on(
          newVal._id + "ROOM_BROADCAST_MESSAGE",
          (message, time, userName) => {
            this.showBroadCastMessage(time, message, userName, "Broadcast");
          }
        );
      }
    },
    profile: function(newProfile, oldProfile) {
      if (newProfile.email === oldProfile.email)
          return;
      if (newProfile.loggedIn) {
          // Restart jitsi connection with new user profile
          this.socket.emit("LEAVE_ROOM");
          this.switchRoom();
      }

      this.socket.off(`MESSAGE_USER_${oldProfile.email}`);
      this.socket.on(
        `MESSAGE_USER_${newProfile.email}`,
        (message, time, userName) => {
          this.showBroadCastMessage(
            time,
            message,
            userName,
            "Direct Message"
          );
        }
      );
    },
    $route(to, from) {
      this.prevPath = { name: from.name, fullPath: from.fullPath };
    }
  },

  computed: {
    ...mapState({
      controls: (state) => state.user.controls,
      isBreakoutRoomsHidden: state => state.rooms.isBreakoutRoomsHidden,
      isBreakoutRoomsPinned: state => state.rooms.isBreakoutRoomsPinned,
      mainRoom: state => state.rooms.mainRoom,
      roomToJoin: state => state.rooms.mainRoom,
      currentRoom: state => state.rooms.currentRoom,
      currentParticipant: state => state.rooms.currentParticipant,
      name: state => state.rooms.name,
      conferenceId: state => state.rooms.conferenceId,
      participants: state => state.rooms.participants,
      showControls: state => state.rooms.showControls,
      loggedIn: state => state.user.profile.loggedIn,
      email: state => state.user.profile.email,
      loginDomainsEnabled: state => state.mainRoomConfig.currentRoom.enableLoginDomains,
      allowedDomains: state => state.mainRoomConfig.currentRoom.allowedLoginDomains,
      restrictControlsForAnonymousUsers: state => state.mainRoomConfig.currentRoom.restrictControlsForAnonymousUsers,
      showBreakouts: state => state.rooms.showBreakouts,
      profile: state => state.user.profile,
    }),
    ...mapGetters("rooms", {
      socket: "getSocket",
      joinRoom: "joinRoom",
      isAudioMuted: "isAudioMuted",
      isVideoMuted: "isVideoMuted",
      isSwitching: "isSwitchingRoom"
    })
  }
};
</script>

<style scoped>
.el-container {
  height: 100%;
  width: 100%;
}

.end-call {
  fill: #f56c6c;
}

.el-main {
  padding: unset;
}

.el-card {
  margin: 0 5px 5px;
}

.side-panel,
.side-panel__dummy {
  /* z-index: 1; */
  display: flex;
  max-height: 100%;
  flex-direction: column;
  width: 250px !important;
  background-color: #121214;
  transition: all ease-in 0.3s;
  overflow-y: hidden;

}

@media (max-width: 767px){
    .side-panel,
    .side-panel__dummy {
        width: 267px !important;

    }
    .side-panel.hide {
        left: -267px !important;
    }
    .side-panel--small.outward {
        left: 267px !important;
    }
}

@media (hover: none){
    .side-panel,
    .side-panel__dummy {
        width: 267px !important;

    }
    .side-panel.hide {
        left: -267px !important;
    }
    .side-panel--small.outward {
        left: 267px !important;
    }
}

.side-panel.pinned {
  position: relative;
}

.side-pannel.show {
  position: static;
}

.side-pannel.hide {
  position: fixed;
}

aside.side-panel__dummy,
div.facilitator-controls__dummy {
  background-color: transparent;
}

.facilitator-controls__dummy {
  width: 72px;
  height: 50%;
  position: fixed;
  right: 0;
  top: 30%;
  border-radius: 9px 0 0 9px;
  padding: 30px 0px;
  z-index: 1;
}

.facilitator-controls__dummy.shift-left-145 {
  right: 145px;
}

.side-panel.show {
  opacity: 1;
  transition: all ease-in 0.3s;
}

.side-panel.hide {
  opacity: 0;
  width: 0 !important;
  transition: all ease-in 0.3s;
}

.side-panel--small {
  transition: all ease-in 0.3s;
}

.side-panel--small.outward {
    left: 250px;
    z-index: 14;
}

.side-panel--small.inward {
  left: 0px;
}

.room-list {
  flex: 1 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #121214;
}

.incorrect-password-icon {
  margin-bottom: -4px;
}

.main-container {
  position: relative;
  overflow: visible;
  display: flex;
  flex-direction: column;
}

.rooms-screen-container {
    display: flex;
    flex: 1 auto;
    overflow: auto;
}


.stretch-and-stretch {
  display: flex;
  flex-direction: column;
  flex: auto;
}
</style>

<style>
.joined-room-container {
  background-color: #121214;
}

.screen-container {
  flex: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: all ease-in 0.3s;
  overflow: hidden;
}

.el-notification {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

.single-row-video {
  height: 80vh !important;
}

.el-footer .el-button--default {
  padding: 6px;
}

#jitsi-iframe iframe {
  flex: auto;
}
#jitsi-iframe.position-iframe iframe{
    position: relative;
    z-index: 20;
}
</style>
